/* Dubailist — advanced motion layer (GSAP 3 + ScrollTrigger + Flip).
   Loaded after gsap.min.js / gsap-scrolltrigger.min.js / gsap-flip.min.js (all deferred).
   Rules (ui-ux-pro-max): transform/opacity only, expo/power easing for entrances,
   exits ~65% of enters, small staggers, 1–2 focal effects per view, everything off
   under prefers-reduced-motion. */
(() => {
  'use strict';
  const g = window.gsap;
  if (!g) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (window.ScrollTrigger) g.registerPlugin(window.ScrollTrigger);
  if (window.Flip) g.registerPlugin(window.Flip);
  document.documentElement.classList.add('has-gsap');
  g.defaults({ ease: 'expo.out', duration: 0.6 });

  /* ---------- money helpers (theme money format, e.g. "{{amount}} AED") ---------- */
  const fmtMoney = (cents, fmt) => {
    const f = String(fmt || '{{amount}}').replace(/<[^>]*>/g, '');
    const n = (cents / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const nod = Math.round(n).toLocaleString('en');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, nod).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, two);
  };
  const roll = (el, from, to, fmt) => {
    if (!el || from === to) return;
    if (reduce) { el.textContent = fmtMoney(to, fmt); return; }
    const o = { v: from };
    g.to(o, { v: to, duration: 0.9, ease: 'power3.out', onUpdate: () => { el.textContent = fmtMoney(Math.round(o.v), fmt); } });
    g.fromTo(el, { color: to < from ? '#15803D' : '#F97316' }, { color: '', duration: 1.2, ease: 'power1.out', clearProps: 'color' });
  };

  /* ---------- confetti burst (small, short, brand colours) ---------- */
  const confetti = (x, y) => {
    if (reduce) return;
    const colors = ['#F97316', '#FDBA74', '#15803D', '#111111', '#FFECDF', '#F59E0B'];
    for (let i = 0; i < 36; i++) {
      const p = document.createElement('i'); p.className = 'confetti';
      p.style.background = colors[i % colors.length]; p.style.left = x + 'px'; p.style.top = y + 'px';
      document.body.appendChild(p);
      const a = (Math.random() * Math.PI) + Math.PI; const v = 120 + Math.random() * 180;
      g.timeline({ onComplete: () => p.remove() })
        .to(p, { x: Math.cos(a) * v, y: Math.sin(a) * v, rotation: Math.random() * 720 - 360, duration: 0.7, ease: 'power3.out' })
        .to(p, { y: '+=220', opacity: 0, duration: 0.9, ease: 'power1.in' }, '>-0.15');
    }
    if (navigator.vibrate) { try { navigator.vibrate(25); } catch (e) { /* ignore */ } }
  };

  /* =========================================================
     CART DRAWER
     ========================================================= */
  const panelOf = () => $('#CartDrawer .drawer__panel');
  const animateCartIn = (panel) => {
    if (reduce || !panel) return;
    const tl = g.timeline({ defaults: { ease: 'expo.out' } });
    tl.from($$('.cart-head__title > *', panel), { y: -10, opacity: 0, stagger: 0.05, duration: 0.5 }, 0.12);
    const fsb = $('[data-fsb]', panel);
    if (fsb) {
      const p = parseFloat(fsb.getAttribute('data-progress')) || 0;
      tl.from(fsb, { opacity: 0, y: -8, duration: 0.4 }, 0.16)
        .fromTo($$('.fsb__fill, .fsb__truck', fsb), { '--progress': 0 }, { '--progress': p, duration: 1.2 }, 0.22)
        .from($$('.fsb__stop i', fsb), { opacity: 0, y: 6, duration: 0.5, stagger: 0.12 }, 0.3);
    }
    tl.from($$('.cart-line', panel), { x: 60, opacity: 0, duration: 0.6, stagger: 0.06 }, 0.2)
      .from($$('.upsell-row', panel), { y: 18, opacity: 0, duration: 0.5, stagger: 0.06 }, 0.35)
      .from($$('.cart-foot > *', panel), { y: 24, opacity: 0, duration: 0.55, stagger: 0.05 }, 0.18);
    const empty = $('.cart-empty__art', panel);
    if (empty) {
      tl.from(empty, { scale: 0.4, rotation: -12, opacity: 0, duration: 0.8, ease: 'back.out(1.8)' }, 0.15)
        .from($$('.cart-empty--ng > *:not(.cart-empty__art)', panel), { y: 14, opacity: 0, stagger: 0.06, duration: 0.5 }, 0.3)
        .to($$('.cart-empty__art i', panel), { y: -6, duration: 1.2, ease: 'sine.inOut', yoyo: true, repeat: -1, stagger: 0.3 }, 0.8);
    }
  };
  document.addEventListener('drawer:open', (e) => { if (e.detail.id === 'CartDrawer') { fillCartRV(); animateCartIn(panelOf()); } });

  // which line changed and in which direction (for the number roll)
  let lastChange = null;
  document.addEventListener('click', (e) => {
    const q = e.target.closest('#CartDrawer [data-qty-change]');
    if (q) { const line = q.closest('[data-line-key]'); lastChange = { key: line && line.getAttribute('data-line-key'), dir: parseInt(q.getAttribute('data-qty-change'), 10) }; }
    const ck = e.target.closest('[data-checkout]');
    if (ck) { ck.classList.add('is-loading'); }
  }, true);

  document.addEventListener('cart:rendered', (e) => {
    const { panel, prev, flipState } = e.detail;
    // drawer closed (e.g. add to cart from a product page): the open choreography will run instead
    if (!panel.closest('.drawer').classList.contains('is-open')) { lastChange = null; return; }
    const fmt = panel.getAttribute('data-money-format');
    // 1) lines glide to their new positions; new lines slide in with a highlight
    if (flipState && window.Flip) {
      window.Flip.from(flipState, {
        targets: $$('[data-flip-id]', panel), duration: 0.55, ease: 'power3.inOut', absolute: false,
        onEnter: (els) => { els.forEach((el) => el.classList.add('is-new')); return g.fromTo(els, { x: 60, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6, ease: 'expo.out' }); }
      });
    } else if (!prev.hadLines) { animateCartIn(panel); }
    // 2) quantity number roll
    if (lastChange && !reduce) {
      const line = $(`[data-line-key="${CSS.escape(lastChange.key)}"]`, panel);
      const input = line && $('.qty__roll input', line);
      if (input) g.fromTo(input, { yPercent: lastChange.dir > 0 ? 70 : -70, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.45, ease: 'back.out(2)' });
      lastChange = null;
    }
    // 3) totals + savings roll from the old values
    const totalEl = $('.cart-sum__total', panel);
    if (totalEl) { const to = parseInt(totalEl.getAttribute('data-roll'), 10) || 0; const from = prev.estTotal || prev.total; if (from) roll(totalEl, from, to, fmt); }
    const saveEl = $('.cart-head__save [data-roll]', panel);
    if (saveEl && prev.saving) roll(saveEl, prev.saving, parseInt(saveEl.getAttribute('data-roll'), 10) || 0, fmt);
    if (saveEl && !prev.saving && !reduce) g.from(saveEl.closest('.cart-head__save'), { y: 8, opacity: 0, duration: 0.6 });
    const cnt = $('[data-cart-head-count]', panel);
    if (cnt && !reduce && +panel.dataset.count !== prev.count) g.fromTo(cnt, { scale: 1.5 }, { scale: 1, duration: 0.6, ease: 'elastic.out(1, 0.45)' });
    // 4) free-delivery bar: animate from the previous progress, pop milestones, celebrate the unlock
    const fsb = $('[data-fsb]', panel);
    if (fsb) {
      const p = parseFloat(fsb.getAttribute('data-progress')) || 0;
      if (!reduce) g.fromTo($$('.fsb__fill, .fsb__truck', fsb), { '--progress': prev.progress }, { '--progress': p, duration: 1.1, ease: 'expo.out' });
      $$('.fsb__stop.is-hit i', fsb).forEach((dot) => {
        const pos = parseFloat(getComputedStyle(dot.parentElement).getPropertyValue('--pos')) || 1;
        if (prev.progress < pos && p >= pos && !reduce) g.fromTo(dot, { scale: 0.2 }, { scale: 1.1, duration: 0.7, ease: 'elastic.out(1, 0.4)', delay: 0.6 });
      });
      if (prev.progress < 1 && p >= 1) {
        const r = $('.fsb__track', fsb).getBoundingClientRect();
        setTimeout(() => confetti(r.right - 10, r.top), 650);
        if (!reduce) g.from($('.fsb__msg', fsb), { scale: 0.9, opacity: 0, duration: 0.6, ease: 'back.out(2)', delay: 0.4 });
      }
    }
    // 5) cross-sell cards drift in
    if (!reduce) g.from($$('.upsell-row', panel), { y: 14, opacity: 0, duration: 0.5, stagger: 0.05, delay: 0.15 });
    fillCartRV();
  });
  // keep the estimated total for the next roll
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#CartDrawer [data-qty-change], #CartDrawer [data-line-remove], [data-add-variant], [data-product-form] [type="submit"]')) return;
    const panel = panelOf(); const t = panel && $('.cart-sum__total', panel);
    if (panel && t) panel.dataset.estPrev = t.getAttribute('data-roll');
  }, true);
  document.addEventListener('cart:rendered', (e) => { if (e.detail.panel.dataset.estPrev) e.detail.prev.estTotal = +e.detail.panel.dataset.estPrev; }, true);

  // swipe a line left to remove (touch); snaps back with a spring if not far enough
  let drag = null;
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'touch') return;
    const inner = e.target.closest('#CartDrawer .cart-line__inner'); if (!inner || e.target.closest('button, input, a')) return;
    drag = { inner, x0: e.clientX, y0: e.clientY, dx: 0, active: false };
  }, { passive: true });
  document.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
    if (!drag.active) { if (Math.abs(dy) > 10) { drag = null; return; } if (Math.abs(dx) > 10) drag.active = true; else return; }
    const rtl = document.dir === 'rtl'; const v = rtl ? Math.max(0, dx) : Math.min(0, dx);
    drag.dx = v; g.set(drag.inner, { x: v });
  }, { passive: true });
  const endDrag = () => {
    if (!drag) return; const d = drag; drag = null; if (!d.active) return;
    const w = d.inner.offsetWidth;
    if (Math.abs(d.dx) > Math.min(110, w * 0.35)) {
      g.to(d.inner, { x: (d.dx < 0 ? -1 : 1) * w, duration: 0.25, ease: 'power2.in', onComplete: () => { const b = $('[data-line-remove]', d.inner.closest('.cart-line')); if (b) b.click(); } });
    } else g.to(d.inner, { x: 0, duration: 0.6, ease: 'elastic.out(1, 0.55)' });
  };
  document.addEventListener('pointerup', endDrag); document.addEventListener('pointercancel', endDrag);

  // empty-cart "recently viewed" mini rail
  function fillCartRV() {
    const wrap = $('#CartDrawer [data-cart-rv]'); if (!wrap) return;
    let list = []; try { list = JSON.parse(localStorage.getItem('dl_recent_viewed')) || []; } catch (e) { /* ignore */ }
    list = list.filter((p) => p && p.u).slice(0, 6); if (!list.length) return;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    $('[data-cart-rv-rail]', wrap).innerHTML = list.map((p) => `<a class="sx-prod" href="${esc(p.u)}"><span class="sx-prod__img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="150" height="150">` : ''}${p.d ? `<span class="sx-prod__badge">-${esc(p.d)}%</span>` : ''}</span><span class="sx-prod__title">${esc(p.t)}</span><span class="sx-prod__price"><b>${esc(p.p)}</b></span></a>`).join('');
    wrap.hidden = false;
  }

  if (reduce) return; // everything below is decorative motion only

  /* =========================================================
     SITE-WIDE ADVANCED MOTION (ScrollTrigger)
     ========================================================= */
  const ST = window.ScrollTrigger;
  const noFloat = document.body.classList.contains('no-float');
  if (ST) {
    // hero: content drifts up and fades, media scales gently as you scroll past (scrubbed)
    if (!noFloat) $$('.hero').forEach((hero) => {
      const content = $('.hero__content', hero), media = $('.hero__media', hero);
      const tl = g.timeline({ scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.6 } });
      if (content) tl.to(content, { yPercent: -18, opacity: 0.25, ease: 'none' }, 0);
      if (media) tl.to(media, { scale: 1.08, yPercent: 8, ease: 'none' }, 0);
    });

    // product rails + tiles: velocity skew while scrolling (subtle, clamped), springs back at rest
    const skewTargets = noFloat ? [] : $$('.rail, .tiles');
    if (skewTargets.length) {
      const setters = skewTargets.map((el) => { el.classList.add('gs-skew'); return g.quickTo(el, 'skewY', { duration: 0.5, ease: 'power3' }); });
      ST.create({ onUpdate: (self) => { const v = g.utils.clamp(-3, 3, self.getVelocity() / -400); setters.forEach((s) => s(v)); } });
      ST.addEventListener('scrollEnd', () => setters.forEach((s) => s(0)));
    }

    // category tiles flip up in 3D as a batch
    if (!noFloat) ST.batch('.tile', { start: 'top 92%', once: true, onEnter: (els) => g.fromTo(els, { rotationX: -55, y: 30, opacity: 0, transformPerspective: 700, transformOrigin: '50% 100%' }, { rotationX: 0, y: 0, opacity: 1, duration: 0.9, stagger: 0.06, ease: 'expo.out', clearProps: 'transform' }) });

    /* ---------- MOTION v3 — editorial (reference: ezlir.com) ----------
       Smoothness rules: reveals are CSS transitions on transform/opacity (run on the compositor, not the
       main thread); one trigger per section so a section arrives as one movement; no clip-path or image
       zoom animations (they repaint every frame); no scroll-scrubbed parallax. */
    if (noFloat) {
      const vh = window.innerHeight;
      const OWN = '[data-reveal], .rail, .is-split, .split-word, .hero, .brand-spot__panel, .promo-banner, .pw-card, .faq details, .tile, .card, .gallery__track, .sticky-atc, .tabbar, dialog, .drawer, script, style, template, noscript, link, meta';
      const OWNED = OWN.split(', ').slice(0, 10).join(', ');
      // blocks that have their own place in the choreography
      const NAMED = '[data-reveal], .pw-card, .faq details, .brand-spot__panel, .brand-spot__panel > :not(.brand-spot__name)';
      const collect = (el, depth, out) => {
        Array.from(el.children).forEach((c) => {
          if (c.matches(OWN) || c.hidden) return;
          const cs = getComputedStyle(c);
          if (cs.display === 'none' || cs.position === 'fixed' || cs.visibility === 'hidden') return;
          const r = c.getBoundingClientRect(); if (!r.height || !r.width) return;
          const kids = Array.from(c.children).filter((k) => k.getBoundingClientRect().height > 0).length;
          const ownsInside = c.querySelector(OWNED);
          const big = r.height > vh * 0.55 && kids > 1;
          const isList = kids > 2 && /^(UL|OL|NAV)$/.test(c.tagName);
          const row = kids >= 3 && r.height > 80 && /grid|flex/.test(cs.display);
          const wrap = (kids > 1 && /^(SECTION|ARTICLE)$/.test(c.tagName)) || (kids >= 1 && (c.tagName === 'FOOTER' || (c.classList.contains('page-width') && kids > 1) || c.classList.contains('footer__grid') || c.classList.contains('footer__bottom')));
          if (depth < 8 && (ownsInside || big || isList || row || wrap || cs.position === 'sticky')) collect(c, depth + 1, out);
          else out.push(c);
        });
      };
      const byOrder = (a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
      const delay = (i) => (i === 0 ? 0 : 120 + Math.min(i - 1, 8) * 80);   // same steps as the Motion Picker (heading first, then 80ms per block)

      const secIO = new IntersectionObserver((ents) => ents.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('ez-in'); en.target.querySelectorAll('.is-split').forEach((h) => h.classList.add('is-in'));
        const head = en.target.querySelector('.section__head'); if (head) head.classList.add('is-in');
        secIO.unobserve(en.target);
      }), { rootMargin: '0px 0px -14% 0px' });
      // tall sections (long product grids): reveal row by row, each batch in reading order
      const soloIO = new IntersectionObserver((ents) => {
        let k = 0;
        ents.filter((en) => en.isIntersecting).sort((x, y) => byOrder(x.target, y.target)).forEach((en) => {
          en.target.style.setProperty('--d', (Math.min(k++, 8) * 80) + 'ms'); en.target.classList.add('ez-in'); soloIO.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });

      $$('#MainContent > .shopify-section, .shopify-section-group-footer-group').forEach((sec) => {
        const r = sec.getBoundingClientRect();
        if (!r.height || r.top < vh * 0.92) return;               // on screen at load: first-paint CSS handles it
        const found = []; collect(sec, 0, found);
        const parts = found.concat($$(NAMED, sec)).filter((x, i, arr) => arr.indexOf(x) === i).sort(byOrder);
        if (r.height > vh * 1.25) {
          sec.classList.add('ez-on');
          parts.forEach((p) => p.classList.add('ez-solo')); parts.forEach((p) => soloIO.observe(p));
          secIO.observe(sec);
        } else {
          parts.forEach((p, i) => { p.setAttribute('data-ez-part', ''); p.style.setProperty('--d', delay(i) + 'ms'); });
          sec.classList.add('ez-on'); secIO.observe(sec);
        }
      });
      // content that arrives later inside a section still waiting for its entrance (brand rails, recommendations)
      new MutationObserver((muts) => muts.forEach((m) => m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        const sec = n.closest('.ez-on:not(.ez-in)'); if (!sec) return;
        const items = (n.matches('[data-reveal]') ? [n] : []).concat(Array.from(n.querySelectorAll('[data-reveal]')));
        items.forEach((it, i) => { it.setAttribute('data-ez-part', ''); it.style.setProperty('--d', delay(i + 1) + 'ms'); });
      }))).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });

      // marquees (trust chips, brands) run faster while you scroll, then ease back to their resting speed
      const anims = $$('.marquee__track').flatMap((t) => (t.getAnimations ? t.getAnimations() : []));
      if (anims.length) {
        let rate = 1, cur = 1;
        ST.create({ onUpdate: (self) => { rate = Math.min(3, 1 + Math.abs(self.getVelocity()) / 1200); } });
        g.ticker.add(() => { rate += (1 - rate) * 0.05; const next = cur + (rate - cur) * 0.12; if (Math.abs(next - cur) > 0.005) { cur = next; anims.forEach((an) => { an.playbackRate = cur; }); } });
      }

      // magnetic hero buttons (desktop): follow the cursor a little, spring back on leave
      if (fine) $$('.hero .btn').forEach((btn) => {
        btn.addEventListener('mousemove', (e) => { const r = btn.getBoundingClientRect(); g.to(btn, { x: (e.clientX - r.left - r.width / 2) * 0.3, y: (e.clientY - r.top - r.height / 2) * 0.3, duration: 0.4, ease: 'power2.out' }); });
        btn.addEventListener('mouseleave', () => g.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' }));
      });
    }

    // promo banners: clip-path wipe in
    if (!noFloat) $$('.promo-banner').forEach((el) => g.from(el, { clipPath: 'inset(0 100% 0 0 round 16px)', duration: 1.1, ease: 'expo.inOut', scrollTrigger: { trigger: el, start: 'top 88%', once: true } }));

    // why-us icons: draw-in pop as the block arrives
    // (the items themselves fade in via data-reveal; GSAP only pops the icons, with explicit end values so the two never fight)
    ST.batch('.why__item > .icon, .why__item svg:first-child', { start: 'top 90%', once: true, onEnter: (els) => g.fromTo(els, { scale: 0.6, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.8, stagger: 0.09, ease: 'back.out(1.6)', clearProps: 'transform,opacity' }) });

    // product page: gallery gently parallaxes against the sticky info column (desktop only)
    if (!noFloat && window.matchMedia('(min-width: 990px)').matches) {
      $$('.gallery__slide img').slice(0, 1).forEach((img) => g.to(img, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: img, start: 'top top', end: 'bottom top', scrub: true } }));
    }

    window.addEventListener('load', () => ST.refresh());
  }

  /* ---------- product page: "Add to cart" button breath once after the price is read ---------- */
  const atc = $('[data-main-product] [data-add-button]');
  if (atc && !atc.disabled) {
    g.timeline({ delay: 2.4 }).to(atc, { scale: 1.03, duration: 0.25, ease: 'power2.out' }).to(atc, { scale: 1, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
  }

  /* ---------- magnetic checkout button (desktop, single focal element) ---------- */
  if (fine) {
    document.addEventListener('pointermove', (e) => {
      const b = e.target.closest && e.target.closest('.btn--checkout');
      $$('.btn--checkout.is-mag').forEach((x) => { if (x !== b) { x.classList.remove('is-mag'); g.to(x, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.5)' }); } });
      if (!b) return; b.classList.add('is-mag');
      const r = b.getBoundingClientRect();
      g.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.08, y: (e.clientY - r.top - r.height / 2) * 0.25, duration: 0.4, ease: 'power3.out' });
    }, { passive: true });
  }
})();
